"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _router = _interopRequireDefault(require("./contexts/core/router"));
var _weverCore = _interopRequireDefault(require("wever-core"));
var _core = require("./services/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * App initiliaze Global Context Provider and Layout.
 */
const Index = props => {
  const {
    token,
    locale,
    editionMode
  } = props;
  if (token) {
    _core._Security.authenticate(token, null);
  }
  return /*#__PURE__*/_react.default.createElement(_weverCore.default, {
    editionMode: editionMode,
    locale: locale
  }, /*#__PURE__*/_react.default.createElement(_router.default, {
    propsContext: props
  }));
};

// S'il y a besoin de passer des choses à votre composant.
Index.propTypes = {
  token: _propTypes.default.string,
  locale: _propTypes.default.string,
  editionMode: _propTypes.default.bool
  // children: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType])
};
Index.defaultProps = {
  token: null,
  locale: null,
  editionMode: false
};
var _default = exports.default = Index;